export default __webpack_public_path__ + "static/media/Polan.d6a52f55.svg";